var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJoinable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "joinable-a",
    width: 6,
    height: 16,
    x: 8,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "joinable-b",
    width: 6,
    height: 16,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#joinable-a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#1C4D5E"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 15,
    x: 0.5,
    y: 0.5
  }), /*#__PURE__*/React.createElement("use", {
    strokeDasharray: "2 2",
    strokeWidth: 2,
    mask: "url(#joinable-b)",
    xlinkHref: "#joinable-a"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinable);
export default __webpack_public_path__ + "static/media/joinable.63bbcbfefe3c49b58a2e718a9d66a512.svg";
export { ForwardRef as ReactComponent };